import React, { HTMLInputTypeAttribute, InputHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';

import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  type: HTMLInputTypeAttribute;
  icon?: React.ComponentType<IconBaseProps>;
  register: any;
  ref?: HTMLInputElement,
  disabledd?: boolean;
  uppercase?: boolean;
}

const Input: React.FC<InputProps> = ({ name, type, label, register, required, disabledd, uppercase, ref, ...rest }) => {
  
  return (
    <Container disabledd={disabledd} uppercase={uppercase}>
      <input name={name} id={name} type={type} ref={ref} {...register(name, { required })} {...rest} />
      <label htmlFor={name}>{label}</label>
    </Container>
  );
};

export default Input;